var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "listToggle";
var PLUGIN_VERSION = "v2";

var DEFAULTS = {
  container: '.listToggle table',
  listItem: 'tr',
  defaultLinesCount: 3,
  effect: 'fadeToggle',
  toggleClass: 'toggled',
  togglingClass: 'toggling',
  hiddenClass: 'hidden'
};

/**
 * set basic variables
 * create options and settings for this instance
 * @param element - DOM Element the plugin is applied to
 * @param options - custom settings to be merged with DEFAULTS
 * @constructor
 */
var ListToggle = function (element, options) {
  this.element = element;
  this.state = 0;
  this.$me = $(this.element);

  // merge options
  this.options = $.extend(true, {}, DEFAULTS, options);
  this._defaults = DEFAULTS;
  this.initialise();
};

/**
 * init function
 */
ListToggle.prototype.initialise = function () {
  this.getOptionsFromDataset();
  this.handleListItems(false);
  this.listenForClick();
};

ListToggle.prototype.getOptionsFromDataset = function () {
  var self = this,
      dataDefaultLinesCount = self.$me.data('defaultLinesCount');

  if (typeof(dataDefaultLinesCount) != 'undefined') {
    self.options.defaultLinesCount = parseInt(dataDefaultLinesCount);
  }
};

ListToggle.prototype.listenForClick = function () {
  var self = this;

  self.$me.on('click', function(e) {
    e.preventDefault();
    var defaultText = $(this).data('textToggleDefault');
    var newText = $(this).data('textToggleToggled');
    if ( self.state == 0 ) {
      $(this).html(newText);
      self.handleListItems(true);
      self.state = 1;
    } else {
      $(this).html(defaultText);
      self.handleListItems(true);
      self.state = 0;
    }

  });
};

ListToggle.prototype.handleListItems = function (enableEffect) {
  var self = this,
      affectedElements = $(this.options.container + ' ' + this.options.listItem + ':gt(' + Number(this.options.defaultLinesCount - 1) + ')');
  if ((enableEffect) && (this.options.effect == 'fadeToggle')) {
    $(self.options.container).toggleClass(self.options.toggleClass).addClass(self.options.togglingClass);
    $(affectedElements).removeClass(self.options.hiddenClass).fadeToggle(function(){
        self.handleVisibleState($(this));
		$(self.options.container).removeClass(self.options.togglingClass);
    });
  }
  else {
    $(affectedElements).removeClass(self.options.hiddenClass).toggle();
    $(this.options.container).toggleClass(this.options.toggleClass);
    self.handleVisibleState($(affectedElements));
  }
};

ListToggle.prototype.handleVisibleState = function ($element) {
  $element.each(function(){
      if ($(this).is(':visible')) {
          $(this).removeAttr('style');
      }
  })
};

/**
 * decide, which methods will be "public"
 */
var API = {
  //method: PluginSkeleton.prototype.method
  //loadMarkers: GoogleMap.prototype.loadMarkers
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *    if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *    if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
  var args = arguments;

  return this.each(function () {
    var $this = $(this);

    // get plugin instance
    var plugin = $this.data('plugin_' + PLUGIN_NAME);

    // if there's not, create one
    if (!plugin) {
      plugin = new ListToggle(this, value);
      $this.data('plugin_' + PLUGIN_NAME, plugin);
    }
    // if there is and first parameter is in predefined API methods, call it with rest of params
    else if (API[value]) {
      plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
    }
  });
};

/**
 * setDefaults with $.pluginSkeleton.setDefaults();
 */
$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
$[PLUGIN_NAME].setDefaults = function (newOptions) {
  DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/edeeshop/jquery.list-toggle.js